import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class EventRoute extends Route 
{
	@service store;
	
	model(params) 
	{
		return this.store.findRecord('Event', params.event_id);
	}
}
